function TrainNumbersController(stateService, toasterService, userService, $state) {
  const ctrl = this;

  ctrl.$onInit = () => {
    let selectedWorkspace = stateService.getSelectedWorkspace();
    ctrl.workspaceId = selectedWorkspace.id;
    ctrl.isLocked = selectedWorkspace.deployable;
    ctrl.workspaceName = selectedWorkspace.name;
    if (!ctrl.workspaceId) $state.go('pis.workspaces');
    ctrl.dataLoading = true;
    stateService.getTrainNumbers(ctrl.workspaceId).then(data => {
      ctrl.trainNumbers = data.train_numbers;
      if (ctrl.trainNumbers) {
        // Make single string of variables that is used in search filtering
        ctrl.trainNumbers.map(trainNumber => {
          trainNumber.allVariables = "";
          if (trainNumber.variables && trainNumber.variables.length > 0) {
            const variables = trainNumber.variables.map(function (variable) { return variable.name + "(" + variable.value + ")"; });
            trainNumber.allVariables = variables.toString().replaceAll(",", " ");
          }
        });
      }
      ctrl.dataLoading = false;
    });
    ctrl.editMode = false;
    ctrl.modalOptions = {
      name: 'train number',
      fields: [
        { name: 'Number', key: 'number', type: 'row' },
        { name: 'Run', key: 'run', type: 'row' },
        { name: 'Variables', key: 'variables', type: 'list', listKey: 'name' }
      ],
      deleteCheck: false,
    };
    ctrl.hasCommit = userService.hasCommitPIS();
    ctrl.hasEdit = userService.hasEditPIS();
  };

  ctrl.setEditMode = () => {
    ctrl.editMode = true;
  };

  ctrl.goBackToList = () => {
    ctrl.editMode = false;
    ctrl.selection = null;
    stateService.getTrainNumbers(ctrl.workspaceId).then(data => ctrl.trainNumbers = data.train_numbers);
  };

  ctrl.onToggleEdit = event => {
    ctrl.editMode = event.editMode;
    ctrl.selection = event.trainNumber;
  };

  ctrl.onFormSubmit = event => {
    ctrl.editMode = event.mode;
    stateService.getTrainNumbers(ctrl.workspaceId).then(data => ctrl.trainNumbers = data.train_numbers);
    ctrl.selection = null;
  };

  ctrl.onDelete = event => {
    stateService.deleteTrainNumber(ctrl.workspaceId, event.trainNumberId).then(
      response => {
        stateService.getTrainNumbers(ctrl.workspaceId).then(data => ctrl.trainNumbers = data.train_numbers);
        toasterService.success('toaster.pis-event', 'toaster.pis-delete-train-number-successful');
      },
      function(e) {
        toasterService.error('toaster.pis-event', 'toaster.pis-delete-train-number-failure');
        console.log(e);
      }
    );
  };

  ctrl.exportToCsv = () => {
    if (ctrl.trainNumbers) {
      let rows = [];
      let titleRow = [];
      titleRow.push("Id", "PTI Code", "Variables");
      rows.push(titleRow);
      ctrl.trainNumbers.map(trainNumber => {
        let row = [];
        row.push(trainNumber.id);
        row.push(trainNumber.number);
        row.push(trainNumber.allVariables);
        rows.push(row); 
      });
      let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      const fileName = ctrl.workspaceName + "_PTI_CODES.csv";
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    }
  }
}

angular
  .module('pis-tool.module')
  .controller('TrainNumbersController', TrainNumbersController);
